import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import { useNavigate } from 'react-router-dom';
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';
import { Grid, Box, MenuItem, Card, CardContent } from '@mui/material';

import ApiService from '../../../../services/ApiService';
import LoadingSpinner from '../../../../components/Components/LoadingSpinner';
import ModalConfirmation from '../../../../components/Modals/ModalConfirmation';
import ButtonBalanceCashAdvanceView from './Buttons/ButtonBalanceCashAdvanceView';
import HeaderInfo from '../../../../components/Components/HeaderInfo';
import CustomToastContainer, { CustomDatePicker, Selection } from '../../../../components/ui';
import { setDateFormat } from '../../../../utils/date';
import { PrintExcel, PrintPDF } from '../../../../utils/reusableFunction';

const BalanceCashAdvanceView = forwardRef((props, ref) => {
    const [isLoadingBackDrop, setIsLoadingBackDrop] = useState(true);
    const history = useNavigate();
    const paramRegUserAccess = 'regUserAccess/regUserAccess';
    const [DataRegUserAccess, setDataRegUserAccess] = useState([]);

    const [DateNow, setDateNow] = useState('');
    const CustomCompanyList = [
        { id: 1, name: 'Per Company' },
        { id: 2, name: 'Regional Company' }
    ];
    const [CustomCompany, setCustomCompany] = useState(1);

    const [isModalConfirmation, setIsModalConfirmation] = useState(false);
    const [titleModalConfirmation, setTitleModalConfirmation] = useState('');
    const [titleConfirmation, setTitleConfirmation] = useState('');

    const BreadcrumbsItems = [
        { label: 'Majura', link: '/Majura', style: '' },
        { label: 'Balance Cash Advance Report', link: '/Majura/BalanceCashAdvanceListReport', style: { color: '#0087C2', fontWeight: '700' } },
    ];

    useImperativeHandle(ref, () => ({
        localSave() {

        }
    }));

    useEffect(() => {
        document.title = 'Balance Cash Advance Report - ' + JSON.parse(localStorage.getItem('branchName'));
        getDataAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const selectCustomCompany = (CustomCompany, setCustomCompany) => {
        return (
            <Selection
                id='0'
                fullWidth={true}
                label="Custom Company"
                value={CustomCompany}
                placeholder={'Select Custom Company'}
                onChange={(e) => setCustomCompany(e.target.value)}
                disabled
            >
                {
                    CustomCompanyList.map((data) => (
                        <MenuItem sx={{ fontSize: '12px' }} id={data.id} key={data.id} value={data.id}>
                            {data.name}
                        </MenuItem>
                    ))
                }
            </Selection>
        )
    }

    function getDateNow() {
        setIsLoadingBackDrop(false);
        setDateFormat(new Date(), setDateNow);
    }

    function handleDateNow(value) {
        setDateNow(value);
    }

    const getDataAccess = () => {
        setIsLoadingBackDrop(true);
        let params = [];
        let pId = 0;
        let listMenu = JSON.parse(localStorage.getItem("dataMenuCode")) || [];
        let hasAccess = false

        const indexMenu = listMenu.findIndex((elm) => elm.code === 'OSHOR')
        if (indexMenu !== -1) {
            pId = listMenu[indexMenu].id
            hasAccess = true
        }

        if (hasAccess) {
            params = [
                ...params,
                { 'attr': 'permissionId', 'value': '' + pId },
                { 'attr': 'userId', 'value': '' + JSON.parse(localStorage.getItem("userId")) },
                { 'attr': 'roleId', 'value': '' + JSON.parse(localStorage.getItem("roleId")) }
            ]
            ApiService.IdentityPostByPage(paramRegUserAccess, 'PAGE', 1, 100, params, [])
                .then((response) => {
                    if (response.data.code === 200) {
                        setDataRegUserAccess(response.data.data.userAccess);

                        getDateNow();
                    }
                })
                .catch(function (error) {
                    console.error('error saat fetch', error)
                    history('/Majura');
                })
        }
        else {
            history('/Majura');
        }
    }

    const handleClickConfirmation = () => {
        if (isModalConfirmation === false) {
            setIsModalConfirmation(true);
        }
        else {
            setIsModalConfirmation(false);
        }
    }

    function ConfirmationBBA() {
        if (titleConfirmation === 'Print PDF') {
            PrintPDFData();
        }
        else if (titleConfirmation === 'Print Excel') {
            PrintExl();
        }
        setIsModalConfirmation(false);
    }

    const PrintData = () => {
        setTitleConfirmation('Print PDF')
        setTitleModalConfirmation('Balance Cash Advance Report');
        handleClickConfirmation();
    };

    const PrintExcelData = () => {
        setTitleConfirmation('Print Excel')
        setTitleModalConfirmation('Balance Cash Advance Report');
        handleClickConfirmation();
    }

    function PrintPDFData() {
        setIsLoadingBackDrop(true);
        let params = [
            {
                "attr": "date",
                "value": DateNow
            }
        ]

        let reportLink = 'Reports/Finance/Print/Cashier/BalanceCashAdvanceListReport/BalanceCashAdvanceListReport/PrintBalanceCashAdvanceList?typeReport=pdf';
        PrintPDF(setIsLoadingBackDrop, 'Balance Cash Advance', reportLink, params);
    }

    function PrintExl() {
        setIsLoadingBackDrop(true);
        let params = [
            {
                "attr": "date",
                "value": DateNow
            }
        ]

        let reportLink = 'Reports/Finance/Print/Cashier/BalanceCashAdvanceListReport/BalanceCashAdvanceListReport/PrintBalanceCashAdvanceList?typeReport=xls';
        PrintExcel(setIsLoadingBackDrop, 'Balance Cash Advance', reportLink, params);
    }

    const ButtonComponents = () => {
        return (
            <ButtonBalanceCashAdvanceView
                PrintData={PrintData}
                PrintExcel={PrintExcelData}
                DataRegUserAccess={DataRegUserAccess}
            />
        )
    }

    return (
        <Box className='w-100' sx={{ width: '100%', p: 3 }}>
            <CustomToastContainer />
            <Grid container spacing={0} direction="column">
                <HeaderInfo
                    title={'Balance Cash Advance Report'}
                    isJobType={false}
                    BreadcrumbsItems={BreadcrumbsItems}
                    ButtonComponents={ButtonComponents}
                />

                <Grid item xs={12} style={{ 'width': '100%', 'borderRadius': '5px' }}>
                    <div style={{ marginTop: '24px' }}>
                        <Grid
                            container
                            spacing={'32px'}
                        >
                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <Card component="div" style={{ borderRadius: '12px', backgroundColor: '#F2F2F2', padding: '16px 24px' }}>
                                    <CardContent>
                                        <Grid
                                            container
                                            spacing={'16px'}
                                        >
                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                {selectCustomCompany(CustomCompany, setCustomCompany)}
                                            </Grid>

                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <CustomDatePicker
                                                    label='As Per Date'
                                                    variant="standard"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    value={DateNow}
                                                    onChange={(e) => handleDateNow(e)}
                                                    type='date'
                                                    formControlProps={{
                                                        sx: {
                                                            width: '100%',
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

            {
                isLoadingBackDrop && (
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={isLoadingBackDrop}
                    >
                        <LoadingSpinner />
                    </Backdrop>
                )
            }

            {
                isModalConfirmation && (
                    <ModalConfirmation
                        isModal={isModalConfirmation}
                        titleModal={titleModalConfirmation}
                        title={titleConfirmation}
                        handleClick={handleClickConfirmation}
                        ConfirmationData={ConfirmationBBA}
                    />
                )
            }
        </Box>
    )
})

export default BalanceCashAdvanceView